import 'core-js/stable';
import 'regenerator-runtime/runtime';

// components
import ErrorBoundary from './commonComponents/molecules/ErrorBoundary';
import { ErrorContextProvider } from './commonComponents/context/ErrorContext';

// utils
import translationFromBody from './utils/getTranslationFromBody';
import getToolConfig from './utils/getToolConfig';

window.addEventListener('load', () => {
  if (window.dpwsToolLoaderIsLoaded) return;

  const toolsList = require('./commonConstants/toolsList'); // eslint-disable-line global-require
  let isReactImported = false;
  let React;
  let ReactDOM;

  const importReact = () => {
    if (isReactImported) {
      return;
    }
    React = require('react'); // eslint-disable-line global-require
    ReactDOM = require('react-dom'); // eslint-disable-line global-require
    isReactImported = true;
  };

  const renderTool = ({ Tool, toolWrapper, toolName }) => {
    ReactDOM.render(
      <ErrorContextProvider>
        <ErrorBoundary>
          <React.Suspense fallback={<div>{translationFromBody.loading}</div>}>
            <Tool config={getToolConfig(toolWrapper, toolName)} />
          </React.Suspense>
        </ErrorBoundary>
      </ErrorContextProvider>,
      toolWrapper,
    );
  };

  const importTool = (toolName) => {
    switch (toolName) {
      case toolsList.branchLocator.name:
        return import('./tools/branchLocator');
      case toolsList.foundationCalculator.name:
        return import('./tools/foundationCalculator');
      case toolsList.overdraftCalculator.name:
        return import('./tools/overdraftCalculator');
      case toolsList.overdraftUkCalculator.name:
        return import('./tools/overdraftUkCalculator');
      case toolsList.travelMoneyCalculator.name:
        return import('./tools/travelMoneyCalculator');
      case toolsList.hmcibCalculator.name:
        return import('./tools/hmcibCalculator');
      case toolsList.lmrCalculator.name:
        return import('./tools/lmrCalculator');
      case toolsList.savingToGoalCalculator.name:
        return import('./tools/savingToGoalCalculator');
      case toolsList.sfxCalculator.name:
        return import('./tools/sfxCalculator');
      case toolsList.calculatorCreator.name:
        return import('./tools/calculatorCreator');
      default:
        return null;
    }
  };

  Object.values(toolsList).forEach((tool) => {
    const toolsWrapperList = Array.from(document.querySelectorAll(`.${tool.class}`));

    if (toolsWrapperList.length > 0) {
      importReact();
      const Tool = React.lazy(() => importTool(tool.name));
      toolsWrapperList.forEach((toolWrapper) =>
        renderTool({
          Tool,
          toolWrapper,
          toolName: tool.name,
        }),
      );
    }
    return false;
  });

  window.dpwsToolLoaderIsLoaded = true;
});
